module.exports = function() {
  return new Worker(__webpack_public_path__ + "6465e4890a2d56877c6d.worker.js");
};